import React from "react";
import styled from "styled-components";
import DateFromNow from "@backpacker/date/from-now";
import { localize } from "@backpacker/number";
import { FontWeight, ellipsis } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import Icon from "@ui-kit/icon";
import { tr } from "@radarly/i18n";
import { ClusterPost } from "@radarly/models/posts";

export interface IProps {
  post: ClusterPost;
  locale: Locale;
  timezone: Timezone;
}

const TooltipHeader = styled.div`
  margin-bottom: 6px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const TooltipAuthor = styled.div`
  ${ellipsis()};
  max-width: 110px;
  margin-right: 5px;
`;

const StyledIcon = styled(Icon)`
  margin-right: 5px;
`;

const TooltipMetric = styled.div`
  font-weight: ${FontWeight.Normal};
  text-align: left;
  font-size: 12px;
`;

const tooltipScore = (score: number, locale: Locale): string =>
  score ? localize(locale, score) : tr(locale, "DATA_UNKNOWN::LABEL");

const ClusterPostTooltip = ({ post, locale, timezone }: IProps) => {
  return (
    <>
      <TooltipHeader>
        <StyledIcon glyph={post.platform} />
        <TooltipAuthor>{post.author}</TooltipAuthor> -{" "}
        <DateFromNow date={post.date} locale={locale} timezone={timezone} />
      </TooltipHeader>
      <TooltipMetric>
        {tr(locale, `POST::METRIC::ENGAGEMENT`)}
        {tr(locale, "PUNCTUATION::COLON")}{" "}
        {tooltipScore(post.engagementScore, locale)}
      </TooltipMetric>
      <TooltipMetric>
        {tr(locale, `POST::METRIC::REACH`)}
        {tr(locale, "PUNCTUATION::COLON")} {tooltipScore(post.reach, locale)}
      </TooltipMetric>
    </>
  );
};

export default ClusterPostTooltip;
